import { AttributeBadge } from './AttributeBadge.jsx';
import { formatPrice } from '../utils/formatPrice.js';
import { hasPricedPortions } from '../utils/hasPricedPortions.js';

export function ItemCard({ item, currency, itemDisplay, onOpen, isLead = false }) {
  const formattedPrice = itemDisplay.showPrice ? formatPrice(item.price, currency) : null;
  const priceLabel = formattedPrice
    ? `${hasPricedPortions(item) ? 'From ' : ''}${formattedPrice}`
    : null;
  const visibleAttributes = itemDisplay.showAttributes ? (item.attributes ?? []).slice(0, 3) : [];
  const hasLeadImage = isLead && itemDisplay.showImages && item.imageUrl;
  const className = `rm-item-card${hasLeadImage ? ' rm-item-card--lead' : ''}`;

  return (
    <button type="button" className={className} onClick={() => onOpen(item)}>
      {itemDisplay.showImages && item.imageUrl && (
        <img
          className="rm-item-card__image"
          src={item.imageUrl}
          alt=""
          role="presentation"
          loading="lazy"
          decoding="async"
          onError={(event) => {
            event.currentTarget.hidden = true;
          }}
        />
      )}
      <span className="rm-item-card__body">
        <span className="rm-item-card__top">
          <span className="rm-item-card__title-row">
            <span className="rm-item-card__name">{item.name}</span>
            {item.isFeatured && <span className="rm-badge rm-badge--featured">★ Popular</span>}
          </span>
          {priceLabel && <span className="rm-item-card__price">{priceLabel}</span>}
        </span>
        {itemDisplay.showDescription && item.description && (
          <span className="rm-item-card__description">{item.description}</span>
        )}
        {visibleAttributes.length > 0 && (
          <span className="rm-item-card__badges">
            {visibleAttributes.map((attr, i) => (
              <AttributeBadge key={i} label={attr.label} value={attr.value} />
            ))}
          </span>
        )}
      </span>
    </button>
  );
}
